import ApiMixin from '../ApiMixin'
import { IReportingCategories } from 'buddy-api/types/talktrack'

export default class TalkTrackAPI extends ApiMixin<IReportingCategories> {}
